import Image from 'next/image';
import Link from 'next/link';
import React, { useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

export default function popvodbox(props) {
  const [swiper, setSwiper] = useState(null);
  const [tab, setTab] = useState(0);

  let [maxPageCount, setMaxPageCount] = useState(0);
  let [naviCount, setNaviCount] = useState(1);

  useEffect(() => {
    if (swiper != null) {
      swiper.slideTo(0, 0);
    }

    if (tab == 0) {
      setMaxPageCount(props.data.contents1.length / 4);
    } else {
      setMaxPageCount(props.data.contents2.length / 4);
    }
  }, [tab]);

  const result = [];
  if (tab == 0) {
    for (let i = 0; i <= props.data.contents1.length - 1; i += 4) {
      result.push(props.data.contents1.slice(i, i + 4));
    }
  } else {
    for (let i = 0; i <= props.data.contents2.length - 1; i += 4) {
      result.push(props.data.contents2.slice(i, i + 4));
    }
  }

  const [touchX, setTouchX] = useState(0);
  const [touchY, setTouchY] = useState(0);

  const touchStart = (e) => {
    setTouchX(e.changedTouches[0].pageX);
    setTouchY(e.changedTouches[0].pageY);
  };

  const touchEnd = (e) => {
    let diffX = touchX - e.changedTouches[0].pageX;
    let diffY = touchY - e.changedTouches[0].pageY;

    Math.abs(diffX) > Math.abs(diffY)
      ? 0 < diffX
        ? swiper.slideNext()
        : swiper.slidePrev()
      : 0 < diffY
      ? console.log('to top')
      : console.log('to bottom');
  };

  useEffect(() => {
    window.__SBSLogModuleDataLayer = window.__SBSLogModuleDataLayer || [];
  }, []);

  const handleClick = (a, b, c, d) => {
    let conver_current_s = parseInt(c);
    let conver_current_s2 = parseInt(props.loc_idx);

    window.__SBSLogModuleDataLayer.push({
      type: 'content',
      option: {
        moduleId: 'VOD',
        moduleTitle: '지금 뜨는 VOD',
        moduleSubTitle: d,
        moduleActive: 'C',
        moduleSeq: props.loc_idx,
        moduleItemSeq: c,
        programId: b.pgm_id,
        programTitle: b.pgm_nm,
        contentId: b.mda_id, //식별자
        contentTitle: b.pgm_nm + b.srs_no + '회',
        contentNumber: b.srs_no,
        contentType: 'V',
      },
    });
  };

  const handleClick_custom = () => {
    window.__SBSLogModuleDataLayer.push({
      type: 'click',
      option: {
        clickName: '지금뜨는VOD 이용권구매하기',
        clickType: 'NC',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: '',
      },
    });
  };

  return (
    <>
      <div className="mainContents-typeWhite">
        <div className="contentsBlock_w">
          <div className="moduleTitleline_w">
            <h2 className="moduleTitleline-Title">{props.data.list_title}</h2>
          </div>
          <div className="sortingLine_w">
            <div className="tabBtns_w_sortBasic">
              <a
                onClick={() => setTab(0)}
                className={`tabBtn_typeText${tab === 0 ? ' current' : ''}`}
              >
                <span className="tabBtn_text">인기</span>
              </a>
              <a
                onClick={() => setTab(1)}
                className={`tabBtn_typeText${tab === 1 ? ' current' : ''}`}
              >
                <span className="tabBtn_text">최신</span>
              </a>
            </div>
            <a
              href={props.data.alllink_url}
              onClick={(e) => {
                e.preventDefault();
                handleClick_custom();
                setTimeout(() => {
                  window.open(props.data.alllink_url, '_self');
                }, 100);
              }}
              className="btnType-passBuy"
            >
              <span className="iconSvg_pass">
                <i className="hide">이용권 구매하기</i>
              </span>
            </a>
          </div>

          <div className={'listModule_w_vodCuration vodCuration' + props.loc_idx}>
            <Swiper
              onSwiper={(s) => setSwiper(s)}
              threshold={1}
              allowTouchMove={false}
              slidesPerView={1}
              spaceBetween={5}
              slidesPerGroup={1}
              loop={false}
              pagination={{
                el: `.vodCuration${props.loc_idx} .swiper-pagination`,
                clickable: false,
                type: `fraction`,
              }}
              breakpoints={{
                375: {
                  slidesPerView: 1,
                  spaceBetween: 0,
                  grid: {
                    rows: 2,
                  },
                },
                768: {
                  slidesPerView: 1,
                  spaceBetween: 0,
                },
              }}
              navigation={{
                nextEl: `.vodCuration${props.loc_idx} .swiper-button-next`,
                prevEl: `.vodCuration${props.loc_idx} .swiper-button-prev`,
              }}
              modules={[Autoplay, Pagination, Navigation]}
              className="listModuleSlider"
              wrapperClass="SliderContent"
              tour
            >
              {result.map((items, index) => {
                return (
                  <SwiperSlide
                    key={`swiper-slide-${index}`}
                    onTouchStart={touchStart}
                    onTouchEnd={touchEnd}
                  >
                    <div className="listModuleItem swiper-slide">
                      <div className="moduleBoxGroup_w">
                        {items.map((item, index) => {
                          return (
                            <div className="moduleBoxWrap_vod" key={index}>
                              <a
                                href={item.link_url}
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleClick(e, item, index, '인기');
                                  setTimeout(() => {
                                    window.open(
                                      item.link_url,
                                      item.link_new_yn === 'Y' ? '_blank' : '_self'
                                    );
                                  }, 100);
                                }}
                                target={item.link_new_yn === 'Y' ? '_blank' : '_self'}
                                className="mb_link"
                              >
                                <div className="mb_image_w">
                                  <span className="iconSvg_play">
                                    <i className="hide">VOD</i>
                                  </span>
                                  <div className="mb_image_inner">
                                    <img
                                      src={item.img_url}
                                      className="mb_image"
                                      alt={item.img_attr}
                                    />
                                    <div className="mb_label_w">
                                      {item.free_yn === 'Y' && (
                                        <span className="mb_label_free">FREE</span>
                                      )}
                                      {item.age19_yn === 'Y' && (
                                        <span className="mb_label_19">19+</span>
                                      )}
                                    </div>
                                  </div>
                                </div>
                                <div className="mb_info_w">
                                  <span className="mbif_title">{item.pgm_nm}</span>
                                  <div className="mbif_line2">
                                    <span className="mbif_subinfo">{item.srs_no}회</span>
                                    <span className="mbif_date">{item.brd_beg_dd}</span>
                                  </div>
                                </div>
                              </a>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </SwiperSlide>
                );
              })}
            </Swiper>
            <div className="sliderBottom_w">
              <button
                type="button"
                className="btnLineTypeList-Next swiper-button-next"
                onClick={() => setNaviCount(naviCount + 1)}
              >
                <span className="iconSvg_arrow">
                  <i className="hide">다음</i>
                </span>
              </button>
              <div className="swiper-pagination notranslate"></div>
              <button
                type="button"
                aria-label="이전 콘텐츠 보기"
                className="btnLineTypeList-Prev swiper-button-prev"
                onClick={() => setNaviCount(naviCount - 1)}
              >
                <span className="iconSvg_arrow">
                  <i className="hide">이전</i>
                </span>
                <span className="pagingNumber_w">
                  <strong className="pagingNumber-now">{naviCount}</strong>/
                  {maxPageCount}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
